// Finadore CRM Constants

export const LEAD_SOURCES = [
  'Referral',
  'Offline',
  'Online',
  'Instagram',
  'LinkedIn',
  'Email',
  'Mobile',
  'Facebook',
  'Apna Jalandhar',
  'Gymkhana'
];

export const CAMPAIGN_NAMES = [
  'Mobile Stand',
  'No Parking',
  'Organic',
  'Mouse Pad',
  'Bags',
  'Directory',
  'Others'
];

export const LEAD_STATUSES = [
  'New',
  "Didn't Pick Up",
  'Busy / Call After Sometime',
  'Follow Up - Brochure Shared',
  'Interested for Meeting',
  'Meeting Scheduled',
  'Meeting Done - Follow Up',
  'Converted',
  'Closed'
];

export const CLOSE_REASONS = [
  'Not Interested',
  'Language Barrier',
  'Wrong Number',
  'Never Call Again',
  'Duplicate Lead',
  'Investing with Other Broker',
  'Investing Through Bank',
  'Already Has Advisor',
  'Not Ready — Too Early',
  "Didn't Pick Up (Repeated)",
  'Deceased',
  'Other'
];

export const SERVICE_INTERESTS = [
  'Mutual Fund - Lumpsum',
  'Mutual Fund - SIP',
  'SIF',
  'Stethowealth',
  'Portfolio Review',
  'Health Insurance',
  'Term Insurance',
  'Indemnity Insurance',
  'RBI Bonds',
  '54EC Bonds',
  'Fixed Deposit',
  'Loan Against MF',
  'P2P Lending',
  'Tax Planning',
  'Financial Planning',
  'NRI Investments'
];

export const CLIENT_STATUSES = ['Active', 'Inactive', 'Expired', 'Deceased'];

export const CLIENT_TYPES = [
  { value: 'Individual', label: 'Individual', description: 'Individual person' },
  { value: 'Minor', label: 'Minor', description: 'Minor (below 18 years)' },
  { value: 'HUF', label: 'HUF', description: 'Hindu Undivided Family' },
  { value: 'Firm', label: 'Firm', description: 'Partnership Firm' },
  { value: 'Company', label: 'Company', description: 'Private/Public Company' },
  { value: 'Trust', label: 'Trust', description: 'Trust/Society' },
  { value: 'NRI', label: 'NRI', description: 'Non-Resident Indian' }
];

export const TAX_STATUSES = [
  'Resident Individual',
  'NRI',
  'Minor',
  'Company',
  'Partnership'
];

export const KYC_ACQUISITION_TYPES = ['Fresh KYC', 'Old KYC'];

export const KYC_STATUSES = [
  'Validated',
  'Registered',
  'On Hold',
  'Rejected',
  'Under Process',
  'Not Present'
];

export const GENDERS = ['Male', 'Female', 'Other'];

export const PROFESSIONS = [
  'Salaried',
  'Self-Employed',
  'Business Owner',
  'Retired',
  'Student',
  'Homemaker',
  'Professional (Doctor/CA/Lawyer)',
  'Other'
];

export const AUM_RANGES = [
  'Below ₹5L',
  '₹5L–₹25L',
  '₹25L–₹1Cr',
  '₹1Cr–₹5Cr',
  'Above ₹5Cr'
];

export const GUARDIAN_RELATIONSHIPS = ['Father', 'Mother', 'Legal Guardian'];

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Puducherry', 'Chandigarh'
];

export const FOLLOW_UP_TYPES = [
  'General Follow-Up',
  'Purchase',
  'Modifications in SIP',
  'SIP Start',
  'Redemption',
  'STP',
  'Broker Change',
  'Health Insurance',
  'Term Insurance',
  'Contact Details Update',
  'Tax Loss Harvesting'
];

export const LEAD_FOLLOW_UP_TYPES = [
  'SIP Start',
  'General Follow Up',
  'Broker Change',
  'Purchase',
  'SIP Modification',
  'Redemption',
  'Call Reminder',
  'Meeting Follow Up',
  'Others'
];

// Time slots in 15-minute increments
export const TIME_SLOTS = (() => {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const hh = String(h).padStart(2, '0');
      const mm = String(m).padStart(2, '0');
      const label = `${h === 0 ? 12 : h > 12 ? h - 12 : h}:${mm} ${h < 12 ? 'AM' : 'PM'}`;
      slots.push({ value: `${hh}:${mm}`, label });
    }
  }
  return slots;
})();

// Restricted time slots for Call/Meeting: 8:00 AM to 10:00 PM
export const BUSINESS_TIME_SLOTS = TIME_SLOTS.filter(s => {
  const h = parseInt(s.value.split(':')[0]);
  return h >= 8 && h <= 21;
});

// Follow-up time slots: 8:00 AM to 8:00 PM
export const FOLLOWUP_TIME_SLOTS = TIME_SLOTS.filter(s => {
  const h = parseInt(s.value.split(':')[0]);
  return h >= 8 && h <= 19;
});

export const CALL_STATUSES = ['Answered', 'Disconnected', 'Busy'];
export const MEETING_STATUSES = ['Met', 'Not Met', 'Was Busy'];
export const CALL_DURATIONS = ['< 1 min', '1-5 min', '5-10 min', '10-15 min', '15-30 min', '30-60 min', '1+ hr'];
export const MEETING_DURATIONS = ['< 15 min', '15-30 min', '30-60 min', '1-2 hrs', '2+ hrs'];

export const TASK_TYPES = [
  'KYC Updation',
  'Minor to Major',
  'Bank Account Updation',
  'SIP Stop',
  'Nomination Updation',
  'SIP Pause',
  'Name Updation',
  'Name Deletion',
  'Contact Details Updation',
  'Transmission',
  'SIP Start',
  'SIP Modification',
  'STP Start',
  'STP Pause',
  'Switch',
  'Redemption',
  'Purchase',
  'Transfer of Units'
];

export const TASK_STATUSES = ['Pending', 'Under Process', 'Rejection', 'Completed'];

export const REJECTION_REASONS = [
  'Documents Insufficient',
  'Signature Mismatch',
  'Details Incomplete'
];

export const MANDATE_STATUSES = [
  'Pending',
  'Under Process',
  'Approved',
  'Active',
  'Rejected - Signature Mismatch',
  'Rejected - Incomplete Details',
  'Mandate Created with AMC',
  'Mandate Created with BSE'
];

export const AMC_NAMES = [
  'SBI Mutual Fund',
  'HDFC Mutual Fund',
  'ICICI Prudential Mutual Fund',
  'Axis Mutual Fund',
  'Kotak Mutual Fund',
  'Nippon India Mutual Fund',
  'Aditya Birla Sun Life Mutual Fund',
  'UTI Mutual Fund',
  'DSP Mutual Fund',
  'Tata Mutual Fund',
  'Mirae Asset Mutual Fund',
  'Motilal Oswal Mutual Fund',
  'PPFAS Mutual Fund',
  'Canara Robeco Mutual Fund',
  'Bandhan Mutual Fund',
  'Edelweiss Mutual Fund',
  'Franklin Templeton Mutual Fund',
  'HSBC Mutual Fund',
  'Invesco Mutual Fund',
  'Quantum Mutual Fund',
  'Other'
];

// Task types that require mandate tracking
export const MANDATE_TASK_TYPES = ['SIP Start', 'SIP Modification'];

// Task types that DON'T require folio number via the generic check
// SIP Start and Purchase handle their own folio logic (new/existing)
export const FOLIO_EXEMPT_TASK_TYPES = ['KYC Updation', 'Purchase', 'SIP Start'];

// Task Category Groupings
export const TASK_CATEGORY_MAP = {
  'NFT': ['KYC Updation', 'Minor to Major', 'Bank Account Updation', 'Nomination Updation', 'Name Updation', 'Name Deletion', 'Contact Details Updation', 'Transmission'],
  'FT': ['Switch', 'Redemption', 'Purchase', 'STP Start', 'STP Pause', 'Transfer of Units'],
  'SIP': ['SIP Start', 'SIP Stop', 'SIP Pause', 'SIP Modification']
};

export const TASK_CATEGORY_LABELS = {
  'NFT': 'Non Financial Transactions',
  'FT': 'Financial Transactions',
  'SIP': 'SIP Related'
};

export const getTaskCategory = (taskType) => {
  for (const [cat, types] of Object.entries(TASK_CATEGORY_MAP)) {
    if (types.includes(taskType)) return cat;
  }
  return 'NFT';
};

export const BOND_TYPES = [
  'REC 54 EC Bonds',
  'PFC 54 EC Bonds',
  'RBI Floating Bonds',
  'IRFC 54 EC Bonds'
];

export const PURCHASE_SUB_TYPES = ['Mutual Fund', 'Bonds'];

export const PRIORITIES = ['High', 'Medium', 'Low'];

export const ACTIVITY_TYPES = ['Call', 'Meeting', 'WhatsApp'];

export const SIP_FREQUENCIES = ['Monthly', 'Quarterly', 'Weekly'];

export const SIP_STATUSES = ['Active', 'Paused', 'Stopped'];

export const DOCUMENT_TYPES = [
  'PAN Card',
  'Aadhaar Card',
  'GST Certificate',
  'Photograph',
  'Signature',
  'Cancelled Cheque',
  'Bank Statement',
  'Passbook Copy',
  'Passport',
  'Birth Certificate',
  'Death Certificate'
];

export const PRODUCT_TYPES = [
  { value: 'Mutual Fund - Lumpsum', category: 'Investment' },
  { value: 'Mutual Fund - SIP', category: 'Investment' },
  { value: 'SIF', category: 'Investment' },
  { value: 'Stethowealth', category: 'Advisory' },
  { value: 'Portfolio Review', category: 'Advisory' },
  { value: 'Health Insurance', category: 'Insurance' },
  { value: 'Term Insurance', category: 'Insurance' },
  { value: 'Indemnity Insurance', category: 'Insurance' },
  { value: 'RBI Bonds', category: 'Fixed Income' },
  { value: '54EC Bonds', category: 'Fixed Income' },
  { value: 'Fixed Deposit (FD)', category: 'Fixed Income' },
  { value: 'Loan Against Mutual Fund', category: 'Lending' },
  { value: 'P2P Lending', category: 'Lending' },
  { value: 'Tax Planning', category: 'Advisory' },
  { value: 'Financial Planning', category: 'Advisory' },
  { value: 'NRI Investments', category: 'Advisory' }
];

export const INSURANCE_COMPANIES = [
  'Star Health',
  'HDFC Life',
  'ICICI Lombard',
  'Max Life',
  'LIC',
  'SBI Life',
  'Bajaj Allianz',
  'Tata AIA',
  'Kotak Life',
  'Reliance General',
  'Other'
];

export const PREMIUM_FREQUENCIES = ['Annual', 'Semi-Annual', 'Quarterly', 'Monthly'];

export const POLICY_STATUSES = ['Active', 'Lapsed', 'Cancelled', 'Under Claim', 'Expired'];

export const MEMBER_RELATIONSHIPS = ['Spouse', 'Child', 'Parent', 'Sibling', 'Other'];

export const USER_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'account_manager', label: 'Account Manager' },
  { value: 'operations_manager', label: 'Operations Manager' }
];

export const DESIGNATIONS = [
  'Executive',
  'Senior Executive',
  'Assistant Manager',
  'Deputy Manager',
  'Manager',
  'AVP',
  'VP',
  'Director'
];

export const formatRoles = (roles) => {
  if (!roles || !Array.isArray(roles)) return '';
  const labelMap = { admin: 'Admin', account_manager: 'Account Manager', operations_manager: 'Operations Manager' };
  return roles.map(r => labelMap[r] || r).join(', ');
};

// Short role codes for compact displays (dropdowns, filters)
export const getRoleShortCode = (roles) => {
  if (!roles || !Array.isArray(roles) || roles.length === 0) return '';
  const codeMap = { admin: 'Admin', account_manager: 'AM', operations_manager: 'OM' };
  return roles.map(r => codeMap[r] || r).join('/');
};

// Build dropdown options for users with role code suffix.
// Usage: buildUserOptions(usersList) => [{ value, label: "Name (AM)" }, ...]
export const buildUserOptions = (users) => {
  return (users || [])
    .filter(u => u && u.id)
    .map(u => {
      const code = getRoleShortCode(u.roles || (u.role ? [u.role] : []));
      return { value: u.id, label: code ? `${u.name} (${code})` : u.name };
    });
};

export const USER_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'on_leave', label: 'On Leave' }
];
